module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_promo_bg-ddc13827a18adffd48fae7bf726a2cb2.jpg";